import  * as api from  '@/api/kzActivity/ques'
import * as TYPES from './type';

export default {
  // 课中活动问卷
  async getQuesList({ commit, state }, { paramets, cb }) {
    const result = await api.reqQuesList(paramets)
    commit(TYPES.QUES_LIST, { result})
    cb && cb()
  },
  async reqQuesAdd({ commit, state }, { paramets, cb }) {
    const result = await api.reqQuesAdd(paramets)
    commit(TYPES.QUES_INFO, { result, type: 'add' })
    cb && cb()
  },
  async reqQuesAddTest({ commit, state }, { paramets, cb }) {
    const result = await api.reqQuesAddTest(paramets)
    commit(TYPES.QUES_INFO, { result, type: 'addTest' })
    cb && cb()
  },
  async putQuesEdit({ commit, state }, { paramets, cb }) {
    const result = await api.reqQuesEdit(paramets)
    commit(TYPES.QUES_INFO, { result, type: 'edit' })
    cb && cb()
  },
  async putQuesTestEdit({ commit, state }, { paramets, cb }) {
    const result = await api.reqQuesTestEdit(paramets)
    commit(TYPES.QUES_INFO, { result, type: 'editTest' })
    cb && cb()
  },
  async delQuesTestDel({ commit, state }, { paramets, cb }) {
    const result = await api.reqQuesTestDel(paramets)
    commit(TYPES.QUES_INFO, { result, type: 'delTest' })
    cb && cb()
  },
  async delQuesDel({ commit, state }, { paramets, cb }) {
    const result = await api.reqQuesDel(paramets)
    commit(TYPES.QUES_INFO, { result, type: 'del' })
    cb && cb()
  },
  async getQuesDetail({ commit, state }, { paramets, cb }) {
    const result = await api.reqQuesDetail(paramets)
    commit(TYPES.QUES_INFO, { result, type: 'detail' })
    cb && cb()
  },
  async postQuesMoveUp({ commit, state }, { paramets, cb }) {
    const result = await api.reqQuesMoveUp(paramets)
    commit(TYPES.QUES_INFO, { result, type: 'moveUp' })
    cb && cb()
  },
  async postQuesMoveDown({ commit, state }, { paramets, cb }) {
    const result = await api.reqQuesMoveDown(paramets)
    commit(TYPES.QUES_INFO, { result, type: 'moveDown' })
    cb && cb()
  },
  async getQuesStatistics({ commit, state }, { paramets, cb }) {
    const result = await api.reqQuesStatistics(paramets)
    commit(TYPES.QUES_INFO, { result, type: 'statistics' })
    cb && cb()
  },

  async getVoteStatistics({ commit, state }, { paramets, cb }) {
    const result = await api.reqVoteStatistics(paramets)
    commit(TYPES.QUES_INFO, { result, type: 'statisticsVote' })
    cb && cb()
  },

  async getStudentAnswer({ commit, state }, { paramets, cb }) {
    const result = await api.reqStudentAnswer(paramets)
    commit(TYPES.ANS_LIST, { result })
    cb && cb()
  },

  clearTestItem({ commit, state }, {item, cb}){
    const result = item
    commit(TYPES.QUES_INFO,{ result, type: 'detail' })
   cb && cb()
 }
}